module.exports = "/images/london-30.jpg";